// Workaround for incorrect parsing of material date objects in Firefox
import { Pipe, PipeTransform } from '@angular/core';
import { L10nTranslationService } from 'angular-l10n';
import * as moment from 'moment-timezone';

@Pipe({
  name: 'momentTime'
})
export class MomentTimePipe implements PipeTransform {

  constructor(private translationService: L10nTranslationService) { }

  transform(value: any, locale: string = 'en-US'): any {
    if (value && !value['_isAMomentObject']) {
      value = moment(value);
    }

    const momentLocale = typeof locale === 'string' ? locale.split('-')[0] : 'en';

    if (value && value.tz) {
      return value.tz('America/New_York').locale(momentLocale).format('hh:mm A') + ' EST';
    }
    return null;
  }

}
